import { render } from "./imagenprimera_ingles.vue?vue&type=template&id=80666fa0&scoped=true"
import script from "./imagenprimera_ingles.vue?vue&type=script&lang=js"
export * from "./imagenprimera_ingles.vue?vue&type=script&lang=js"

import "./imagenprimera_ingles.vue?vue&type=style&index=0&id=80666fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80666fa0"]])

export default __exports__